module.exports = __webpack_public_path__ + "img/15.415c451.jpg";